/* eslint-disable @nx/enforce-module-boundaries */
import { HStack, Box, Stack, useBreakpointValue } from '@mybridge/ui';
import React, { useContext, useEffect, useRef, useState, useMemo } from 'react';
import MessageSidebar from './message-sidebar';
import MessageChatBox from './chat-container';
import { SiteShortcutLinks } from 'v4/snippets/dashboard/site-shortcut-links';
import { isDesktop, isMobile } from 'react-device-detect';
import { DashboardMyCircle } from '../dashboard/circle';
import style from '../../components/header/status-dropdown/statusProfile.module.scss';
import { getUserRoomList } from 'v4/store/actions/global.data.actions';
// import { useDispatch } from 'react-redux';
import { useDispatch, useSelector } from 'react-redux';
import { getConnectionsData } from 'v4/store/actions/connection.actions';
import { MatrixContext } from 'packages/mybridgev4/context/chat-context';
import { useInfiniteQuery } from '@tanstack/react-query';
// import { getNextPageFromURL } from 'v4/utils/utils';
import { getNextPageFromURL, convertMatrixConnectionsToRooms } from 'v4/utils/utils';
import { useChatSocket } from 'packages/mybridgev4/hooks/useChatSocket';
import { MyNetworkContext, useMyNetworkContext } from 'v4/components/network/context';
import { useRouter } from 'next/router';

// const SOCKET_SERVER_URL = process.env.SOCKET_URL;
// const TOKEN_NAME = process.env.BASE_TOKEN_NAME;

const MessagePage = () => {
  const {
    selectedChat,
    setOpenMobileChatView,
    openMobileChatView,
     setSelectedChat,
     connectionList,
     setConnectionList,
     roomId, 
     setRoomId,
     newChatDisc
  } = useContext(MatrixContext);

  const router = useRouter();
  const { userProfileInfo } = useSelector((state) => state?.userProfile);
  
  const networkContext = useMyNetworkContext({
    refetchBlockedEnabled: true,
    refetchMyCircleEnabled: true,
  });
  // const [selectedChat, setSelectedChat] = useState(null);
  // const [roomId, setRoomId] = useState(null);
  const [connectionsCount, setConnectionsCount] = useState(null);
  const isMobileViewport = useBreakpointValue({ base: true, md: false });
  // const [connectionList, setConnectionList] = useState([]);
  const dispatch=useDispatch()
  const [isGroupModalOpen, setIsGroupModalOpen] = useState({
    open: false,
    data: '',
  });
  const [totalNotificationCount, setTotalNotificationCount] = useState(0);
  const [isCreateGroupedClicked, setIsCreateGroupedClicked] = useState(false);
  const [groupMemberDetail, setGroupMemberDetail] = useState([]);
  const [isgroupNameModal, setIsgroupNameModal] = useState({
    open: false,
    data: '',
  });
  const [groupName, setGroupName] = useState(null);
  const [networkConnection, setNetworkConnection] = useState([]);
  const [inputSearch, setInputSearch] = useState('');
  const [onlineUsers, setOnlineUsers] = useState({});

  const { socketRef, isConnected, ...socketProps } = useChatSocket({roomId});


  const updateOnlineStatus = (eventData) => {
    const { user_id, presence } = eventData;
    setOnlineUsers(prev => ({
      ...prev,
      [user_id]: presence // 'online' | 'offline' | 'unavailable'
    }));
  };


  // Process WebSocket events
  useEffect(() => {
    const lastEvent = socketProps?.lastEvent;
    if (!lastEvent) return;

    if (lastEvent?.event_name === "presence.update") {
      updateOnlineStatus(lastEvent);
    }
  }, [socketProps?.lastEvent]);


  // Infinite query for room list
  const {
    data: roomsListingPages,
    isFetching: roomsListingFetching,
    isLoading: roomsListingLoading,
    refetch: refetchRoomsListing,
    fetchNextPage: roomsFetchNextPage,
    hasNextPage: roomsHasNextPage,
  } = useInfiniteQuery({
    queryKey: ['rooms-listing', { searchQuery: inputSearch }],
    queryFn: async ({ queryKey, pageParam }) => {
      const resp = (
        await dispatch(
          getUserRoomList({ pageParam, searchQuery: queryKey?.[1]?.searchQuery || '' })
        )
      )?.payload;
      return resp;
    },
    getNextPageParam: (lastPage) => getNextPageFromURL(lastPage?.next),
    refetchOnWindowFocus: false,
    enabled: true,
  });

  // Flatten rooms listing from pages
  const roomsListing = useMemo(() => {
    return [].concat.apply(
      [],
      roomsListingPages?.pages?.map((p) => p?.rooms ?? p?.results ?? [])
    );
  }, [roomsListingPages]);

  // Update connectionList when roomsListing changes
  useEffect(() => {
    if (roomsListing) {
      setConnectionList(roomsListing);
      const totalNotifications = roomsListing?.reduce(
        (sum, room) => sum + (room?.notification_count || 0),
        0
      );
      setTotalNotificationCount(totalNotifications);
    }
  }, [roomsListing, setConnectionList]);

  // Handle room selection from router query parameter
  useEffect(() => {
    if (!router.isReady) return;
  
    const queryRoomId = router.query?.user;
    // if (!queryRoomId) return;
    if (!queryRoomId) {
      setSelectedChat(null);
      setRoomId(null);
      setOpenMobileChatView(false);
      return;
    }

    // Prefer API room listing (paginated "recent chats") when available.
    // Fallback to locally-built Matrix rooms only when the room isn't present in the API page.
    const apiRoom = connectionList?.find((room) => room?.room_id === queryRoomId);
    if (apiRoom) {
      setSelectedChat(apiRoom);
      setRoomId(apiRoom.room_id);
      if (isMobileViewport) {
        setOpenMobileChatView(true);
      }
      return;
    }

    const convertedRooms = convertMatrixConnectionsToRooms(userProfileInfo?.id);
    const localRoom = convertedRooms?.find((room) => room?.room_id === queryRoomId);
    if (localRoom) {
      setSelectedChat(localRoom);
      setRoomId(localRoom.room_id);
      if (isMobileViewport) {
        setOpenMobileChatView(true);
      }
    }
  }, [router.isReady, router?.query?.user, connectionList, userProfileInfo?.id, isMobileViewport]);

  // Fetch network connections on mount
  useEffect(() => {
    dispatch(getConnectionsData({ pageSize: 20 })).then((res) => {
      if (res?.payload?.results) {
        setNetworkConnection(res.payload.results);
      }
    });
  }, [dispatch]);

  // Handle fromUpdateImage case and refetch after group creation
  const fetchRoomList = async (searchQuery = '') => {
    if (searchQuery === "fromUpdateImage") {
      const result = await refetchRoomsListing();
      const updatedRooms = [].concat.apply(
        [],
        result?.data?.pages?.map((p) => p?.rooms ?? p?.results ?? [])
      );
      const openedChat = updatedRooms.find((room) => room?.room_id === selectedChat?.room_id);
      if (openedChat) {
        setSelectedChat(openedChat);
      }
    } else if (searchQuery === '') {
      // Refetch rooms listing when called without searchQuery (e.g., after group creation)
      await refetchRoomsListing();
    } else {
      setInputSearch(searchQuery);
    }
    setIsgroupNameModal({ open: false, data: '' });
    setIsGroupModalOpen({ open: false, data: '' });
  };

  // Get total count from API response, fallback to calculated value
  const roomsTotalCount = roomsListingPages?.pages?.[0]?.count ?? roomsListingPages?.pages?.length * 10;
  return (
    <MyNetworkContext.Provider value={networkContext}>
      <HStack alignItems="stretch" spacing={0} bg="white" minH={isMobile?null:"120vh"}>

<Stack
  display={['none', 'none', 'flex']}
  position="sticky"
  top="64px"
  spacing={2}
  minH="90vh"
  //borderBottom="1px solid #e0e0e094"
  height="500px"
  zIndex="999"
  css={{
    '@media (min-width: 768px) and (max-width: 1227px)': {
      height: '430px',
      minHeight: '70vh',
    },
    '@media (min-width: 1228px) and (max-width: 1535px)': {
      height: '320px',
      minHeight: '58vh',
    },
  }}
        // _css={{
        //   '@media (min-width: 1097) and (max-width: 1279)': {
        //     height: '100px',
        //     minimum
        //   },
        // }}
        className={style.leftNetworkMessage}
      >
        <SiteShortcutLinks />

        {/* <Box> */}
        <Box className={style.hideTitle}>
          <DashboardMyCircle w="230px" h="300px" flex="1" />
        </Box>
      </Stack>

      {/* Message Sidebar */}
      {/* (!isMobile?false:selectedChat) &&  */}
      {/* <Box pos={!isMobile && "sticky"} h={!isMobile && "430px"} top={!isMobile && "64px"} w={{ base: "100%", md: "35%", lg: "35%" }} p={isMobile ? '0' : '1%'}>
        <MessageSidebar
        networkConnection={networkConnection}
         setNetworkConnection={setNetworkConnection}
          roomId={roomId}
          setRoomId={setRoomId}
          socketRef={socketRef}
          onSelectChat={setSelectedChat}
          setConnectionsCount={setConnectionsCount}
          connectionList={connectionList}
          setConnectionList={setConnectionList}
          isGroupModalOpen={isGroupModalOpen}
          setIsGroupModalOpen={setIsGroupModalOpen}
          isCreateGroupedClicked={isCreateGroupedClicked}
          setIsCreateGroupedClicked={setIsCreateGroupedClicked}
          selectedChat={selectedChat}
          groupMemberDetail={groupMemberDetail}
          isgroupNameModal={isgroupNameModal}
          setGroupName={setGroupName}
          groupName={groupName}
          setIsgroupNameModal={setIsgroupNameModal}
          fetchRoomList={fetchRoomList}
          setIsLoading={setIsLoading}
          isLoading={isLoading}
        />
      </Box> */}
{/* (!isMobile?selectedChat:true) &&  */}
      {/* <Box w={{base:"100%", md:"65%"}} p={{base:0, md: 4}} h="90vh" pos={!isMobile && "sticky"} top={!isMobile && "64px"}
            // css={{
            //   '@media (min-width: 768px) and (max-width: 1023px)': {
            //     height: '600px',
            //   },
            //   '@media (min-width: 1024px) and (max-width: 1439px)': {
            //     height: '550px',
            //   },
            //   '@media (min-width: 1440px) and (max-width: 1744px)': {
            //     height: '630px',
            //   },
              
            // }}>
            >
         
        <MessageChatBox
          selectedChat={selectedChat}
          roomId={roomId}
          networkConnection={networkConnection}
          setNetworkConnection={setNetworkConnection}
          setSelectedChat={setSelectedChat}
          onClose={() => setSelectedChat(null)}
          connectionsCount={connectionsCount}
          connectionList={connectionList}
          setConnectionList={setConnectionList}
          isGroupModalOpen={isGroupModalOpen}
          setIsGroupModalOpen={setIsGroupModalOpen}
          isCreateGroupedClicked={isCreateGroupedClicked}
          setIsCreateGroupedClicked={setIsCreateGroupedClicked}
          groupMemberDetail={groupMemberDetail}
          setGroupMemberDetail={setGroupMemberDetail}
          isgroupNameModal={isgroupNameModal}
          setGroupName={setGroupName}
          groupName={groupName}
          setIsgroupNameModal={setIsgroupNameModal}
          fetchRoomList={fetchRoomList}
          setRoomId={setRoomId}
          socketRef={socketRef}
        />
      </Box> */}

      {/* Desktop layout: always show both */}
      {isDesktop && !isMobileViewport && (
        <>
          <Box
            pos="sticky"
            h="430px"
            top="64px"
            w={{ base: "100%", md: "300px", lg: "350px", xl: "380px" }}
            p="1%"
          >
            <MessageSidebar
              networkConnection={networkConnection}
              setNetworkConnection={setNetworkConnection}
              refetchRoomsListing={refetchRoomsListing}
              roomId={roomId}
              setRoomId={setRoomId}
              // socketRef={socketRef}
              onSelectChat={setSelectedChat}
              setConnectionsCount={setConnectionsCount}
              connectionList={connectionList}
              setConnectionList={setConnectionList}
              isGroupModalOpen={isGroupModalOpen}
              setIsGroupModalOpen={setIsGroupModalOpen}
              isCreateGroupedClicked={isCreateGroupedClicked}
              setIsCreateGroupedClicked={setIsCreateGroupedClicked}
              selectedChat={selectedChat}
              groupMemberDetail={groupMemberDetail}
              setGroupMemberDetail={setGroupMemberDetail}
              isgroupNameModal={isgroupNameModal}
              setGroupName={setGroupName}
              groupName={groupName}
              setIsgroupNameModal={setIsgroupNameModal}
              fetchRoomList={fetchRoomList}
              isLoading={roomsListingLoading}
              roomsFetchNextPage={roomsFetchNextPage}
              roomsHasNextPage={roomsHasNextPage}
              roomsTotalCount={roomsTotalCount}
              inputSearch={inputSearch}
              setInputSearch={setInputSearch}
              socketRef={socketRef}
              isSocketReady={isConnected}
              socketProps={socketProps}
              onlineUsers={onlineUsers}
            />
          </Box>

          <Box
            flex="1"
            minW="0"
            p={{ base: 0, md: 0 }}
            pt={{ base: 0, md: 5 }}
            h="90vh"
            pos="sticky"
            top="64px"
          >
            <MessageChatBox
              selectedChat={selectedChat}
              roomId={roomId}
              refetchRoomsListing={refetchRoomsListing}
              networkConnection={networkConnection}
              setNetworkConnection={setNetworkConnection}
              setSelectedChat={setSelectedChat}
              onClose={() => setSelectedChat(null)}
              connectionsCount={connectionsCount}
              connectionList={connectionList}
              setConnectionList={setConnectionList}
              isGroupModalOpen={isGroupModalOpen}
              setIsGroupModalOpen={setIsGroupModalOpen}
              isCreateGroupedClicked={isCreateGroupedClicked}
              setIsCreateGroupedClicked={setIsCreateGroupedClicked}
              groupMemberDetail={groupMemberDetail}
              setGroupMemberDetail={setGroupMemberDetail}
              isgroupNameModal={isgroupNameModal}
              setGroupName={setGroupName}
              groupName={groupName}
              setIsgroupNameModal={setIsgroupNameModal}
              fetchRoomList={fetchRoomList}
              setRoomId={setRoomId}
              socketRef={socketRef}
              isSocketReady={isConnected}
              socketProps={socketProps}
              onlineUsers={onlineUsers}
            />
          </Box>
        </>
      )}

      {/* Mobile layout: either sidebar or chat */}
      {!isDesktop && (
        <>
          {!openMobileChatView ? (
            <Box w="100%" p={0}>
              <MessageSidebar
                networkConnection={networkConnection}
                setOpenMobileChatView={setOpenMobileChatView}
                openMobileChatView={openMobileChatView}
                setNetworkConnection={setNetworkConnection}
                roomId={roomId}
                setRoomId={setRoomId}
                socketRef={socketRef}
                onSelectChat={setSelectedChat}
                setConnectionsCount={setConnectionsCount}
                connectionList={connectionList}
                setConnectionList={setConnectionList}
                isGroupModalOpen={isGroupModalOpen}
                setIsGroupModalOpen={setIsGroupModalOpen}
                isCreateGroupedClicked={isCreateGroupedClicked}
                setIsCreateGroupedClicked={setIsCreateGroupedClicked}
                selectedChat={selectedChat}
                groupMemberDetail={groupMemberDetail}
                setGroupMemberDetail={setGroupMemberDetail}
                isgroupNameModal={isgroupNameModal}
                setGroupName={setGroupName}
                groupName={groupName}
                setIsgroupNameModal={setIsgroupNameModal}
                fetchRoomList={fetchRoomList}
                isLoading={roomsListingLoading}
                roomsFetchNextPage={roomsFetchNextPage}
                roomsHasNextPage={roomsHasNextPage}
                roomsTotalCount={roomsTotalCount}
                inputSearch={inputSearch}
                setInputSearch={setInputSearch}
                onlineUsers={onlineUsers}
              />
            </Box>
          ) : (
            <Box w="100%" p={0} h="90vh">
              <MessageChatBox
                selectedChat={selectedChat}
                roomId={roomId}
                refetchRoomsListing={refetchRoomsListing}
                networkConnection={networkConnection}
                setOpenMobileChatView={setOpenMobileChatView}
                openMobileChatView={openMobileChatView}
                setNetworkConnection={setNetworkConnection}
                setSelectedChat={setSelectedChat}
                onClose={() => setSelectedChat(null)}
                connectionsCount={connectionsCount}
                connectionList={connectionList}
                setConnectionList={setConnectionList}
                isGroupModalOpen={isGroupModalOpen}
                setIsGroupModalOpen={setIsGroupModalOpen}
                isCreateGroupedClicked={isCreateGroupedClicked}
                setIsCreateGroupedClicked={setIsCreateGroupedClicked}
                groupMemberDetail={groupMemberDetail}
                setGroupMemberDetail={setGroupMemberDetail}
                isgroupNameModal={isgroupNameModal}
                setGroupName={setGroupName}
                groupName={groupName}
                setIsgroupNameModal={setIsgroupNameModal}
                fetchRoomList={fetchRoomList}
                setRoomId={setRoomId}
                socketRef={socketRef}
                isSocketReady={isConnected}
                socketProps={socketProps}
                onlineUsers={onlineUsers}
              />
            </Box>
          )}
        </>
      )}
    </HStack>
    </MyNetworkContext.Provider>
  );
};

export default MessagePage;
